var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon16PxClipboardOutline(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.29869 2.5H6.76022C6.2929 2.5 5.91406 2.87883 5.91406 3.34615V3.76923C5.91406 4.23654 6.2929 4.61538 6.76022 4.61538H9.29869C9.76601 4.61538 10.1448 4.23654 10.1448 3.76923V3.34615C10.1448 2.87883 9.76601 2.5 9.29869 2.5Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3571 3.34619H11.6264C11.8508 3.34619 12.066 3.43534 12.2247 3.59402C12.3834 3.75271 12.4725 3.96793 12.4725 4.19234V12.6538C12.4725 12.8782 12.3834 13.0935 12.2247 13.2522C12.066 13.4108 11.8508 13.5 11.6264 13.5H4.43405C4.20963 13.5 3.99441 13.4108 3.83572 13.2522C3.67704 13.0935 3.58789 12.8782 3.58789 12.6538V4.19234C3.58789 3.96793 3.67704 3.75271 3.83572 3.59402C3.99441 3.43534 4.20963 3.34619 4.43405 3.34619H5.70328",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon16PxClipboardOutline);
export default __webpack_public_path__ + "static/media/icon_16px_clipboard_outline.278774711b9575000e7482361f9ec005.svg";
export { ForwardRef as ReactComponent };